import React from 'react';

import {ARCHIVED_ANALYSIS_TOOLTIP_TEXT} from 'analysis-tool/AnalysisToolConstants';
import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import {
  getAddDataFrameAnalysisViewItem,
  getEnabledDatasetCreationMethods,
  trackSelectedDataFrameCreationMethodEvent,
} from 'analysis-tool/data-frame-creation/DataFrameCreationUtils';
import isArchived from 'archive/isArchived';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {AnalysisMainViewItem} from './main-view/MainViewTypes';

export interface AddDataButtonProps {
  actionOrigin: Parameters<typeof trackSelectedDataFrameCreationMethodEvent>[0];
  analysis: AnalysisGraphQL;
  buttonSize: ButtonSize;
  onOpenStepInitializationView: (newSelectedItem: AnalysisMainViewItem) => void;
}
export default function AddDataButton({
  actionOrigin,
  analysis,
  buttonSize,
  onOpenStepInitializationView,
}: AddDataButtonProps): JSX.Element {
  const {analysisToolEnableHeaderRedesign} = useRolloutFlags();
  const dataFrameCreationMethods = getEnabledDatasetCreationMethods();
  const isDisabled = isArchived(analysis);

  return (
    <Tooltip text={isArchived(analysis) ? ARCHIVED_ANALYSIS_TOOLTIP_TEXT : null}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        icon="plus-large"
        size={buttonSize}
        text={analysisToolEnableHeaderRedesign ? 'Add data' : 'Add analysis table'}
        disabled={isDisabled}
        onClick={() => {
          onOpenStepInitializationView(getAddDataFrameAnalysisViewItem());
          if (dataFrameCreationMethods.length === 1) {
            trackSelectedDataFrameCreationMethodEvent(
              actionOrigin,
              analysis.id,
              dataFrameCreationMethods.length,
              dataFrameCreationMethods[0]
            );
          }
        }}
      />
    </Tooltip>
  );
}
